import HttpClient from '../HttpClient'

export class ProfileService {

    static my = async () : Promise<any> => {
        return HttpClient.get('v2/profiles/my')
    }

}
